import { getStaticFormInfos } from 'state/selectors';
import type { AppState } from 'state/state.model';

export function isProductSummaryOpened(state: AppState, tabId: string): boolean {
  const formInfos = getStaticFormInfos(state, tabId);
  return formInfos?.summary?.opened ?? false;
}
